import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { VbFooterLink, VbSnackbarService } from '@viewbid/ui';
import { TranslateService } from '@ngx-translate/core';

/**
 * App-shell wrapper around the @viewbid/ui vb-app-footer (replaces the legacy
 * vb-footer-one): supplies the app's link lists and routes the footer's
 * events. Link ids are route paths (same convention as the header shell), so
 * items carry no href and `(linkSelect)` navigates via the router. Contact
 * details, social URLs, and the legal strip all use the component's
 * production defaults.
 */
@Component({
    selector: 'vb-app-footer-shell',
    templateUrl: './app-footer-shell.component.html',
})
export class AppFooterShellComponent {
    /** Colored logo — the white variant is for dark surfaces only. */
    readonly logoSrc = '/assets/viewbid/images/logo_viewbid.svg';

    /** Same embed URL as the legacy footer — renders the exact place pin. */
    readonly mapSrc =
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2836.0271478170994!2d-63.491813823628554!3d44.69864467107181!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b5a2451439c635d%3A0xc797ab447a9c5975!2s803%20Main%20St%2C%20Dartmouth%2C%20NS%20B2W%203T4!5e0!3m2!1sen!2sca!4v1773241182893!5m2!1sen!2sca';

    readonly hours = 'Mon–Fri · 9:30am–4:30pm';

    readonly browseLinks: VbFooterLink[] = [
        { id: '/home', label: 'Home' },
        { id: '/auctions', label: 'Current auctions' },
        { id: '/about-us', label: 'About us' },
    ];

    readonly infoLinks: VbFooterLink[] = [
        { id: 'terms', label: 'Terms and conditions' },
        { id: '/privacy-policy', label: 'Privacy policy' },
        { id: '/contact-us', label: 'Contact us' },
        { id: '/faq', label: 'FAQ' },
    ];

    constructor(
        private readonly router: Router,
        private readonly snackbarService: VbSnackbarService,
        private readonly translate: TranslateService,
    ) {}

    onLinkSelect(id: string): void {
        if (id === 'terms') {
            // Same behaviour as the legacy footer's displayTerms() — the
            // terms-and-conditions route exists but is deliberately bypassed.
            this.snackbarService.system(
                this.translate.instant('Notifications.contactViewbidForTerms'),
            );
            return;
        }
        this.router.navigate([id]);
    }
}
